import { listResponseSchema } from '@/common/api/schemas.ts';
import { z } from 'zod';

export const typeItemSchema = z.object({
  id: z.string(),
  code: z.string(),
  producerId: z.string(),
});

export type TypeItem = z.infer<typeof typeItemSchema>;

export const typeListResponseSchema = listResponseSchema(typeItemSchema);

export type TypeListResponse = z.infer<typeof typeListResponseSchema>;

export interface CreateTypeData {
  code: string;
  producerId: string;
}

export interface UpdateTypeData extends CreateTypeData {
  id: string;
}
